<template>
  <v-row class="ma-0">
    <v-col cols="12" class="wsp-wallpaper pb-5">
      <v-card class="mx-4 mt-4 mb-0 py-2">
        <v-col v-if="replyMessageSelected.image_url" cols="12" class="pb-0">
          <img :src="replyMessageSelected.image_url" width="100%" />
        </v-col>
        <v-col v-if="replyMessageSelected.caption" cols="12" class="py-1 font-weight-bold">
          <span>{{ replyMessageSelected.caption }}</span>
        </v-col>
        <v-col v-if="replyMessageSelected.content" cols="12" class="py-1">
          <span>{{ replyMessageSelected.content }}</span>
        </v-col>
        <v-col v-if="replyMessageSelected.footer" cols="12" class="py-1 text-caption text--secondary">
          <span>{{ replyMessageSelected.footer }}</span>
        </v-col>
        <v-col cols="12" class="py-0 text-caption text--secondary text-right">
          <span>07:42</span>
        </v-col>
      </v-card>
      <v-col v-if="replyMessageSelected.buttons" cols="12" class="pt-0">
        <v-card
          v-for="(button, i) in replyMessageSelected.buttons"
          :key="i"
          class="mx-1 mt-1 py-1 text-center info--text"
        >
          {{ button.reply.title }}
        </v-card>
      </v-col>
      <v-col v-if="replyMessageSelected.list_options || replyMessageSelected.sections" cols="12" class="pt-0">
        <v-card class="mx-1 mt-1 py-1 text-center info--text">
          <v-icon x-small color="info" class="mr-1"> fas fa-bars</v-icon>
          {{ replyMessageSelected.action_button }}
        </v-card>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "WhatsAppReplyMessagePreview",
  props: {
    replyMessageSelected: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style>
.wsp-wallpaper {
  background-color: #e5ddd5;
  position: relative;
}

.wsp-wallpaper::before {
  background-image: url("https://storage.googleapis.com/wegrou-assets-dev/assets/wsp-wallpaper.png");
  opacity: 0.08;
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
</style>
